import { PathsV1ApplicationSearchPostParametersQuerySelect } from "@/api-schema-enums";
import { useApplicationSearchQuery } from "@/common/api/application/use-application-search.query";
import { SearchableSelect } from "@/components/ui/searchable-select";
import { useMemo } from "react";

interface ApplicationSelectorProps {
  value?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export function ApplicationSelector({ value, onValueChange, disabled, className, id }: ApplicationSelectorProps) {
  const { data, isLoading } = useApplicationSearchQuery({
    options: {
      parameters: {
        pageSize: -1,
        select: [
          PathsV1ApplicationSearchPostParametersQuerySelect.Uuid,
          PathsV1ApplicationSearchPostParametersQuerySelect.Name,
        ],
      },
      body: {},
    },
  });

  const options = useMemo(() => {
    return (
      data?.data?.map((app) => ({
        label: app.name,
        value: app.uuid,
      })) || []
    );
  }, [data]);

  if (isLoading) {
    return <SearchableSelect options={[]} value="" onValueChange={() => {}} className={className} disabled id={id} />;
  }

  return (
    <SearchableSelect
      options={options}
      value={value}
      onValueChange={onValueChange}
      className={className}
      disabled={disabled}
      id={id}
    />
  );
}
